'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { icons } from '@/assets/icons';
import { backgrounds } from '@/assets/materials';
import HexagonalButton from '@/components/bases/HexagonalButton';

export const ExploreHeroSection = () => {
  const openAdminPage = () => {
    window.open(process.env.NEXT_PUBLIC_ADMIN_URL, '_blank');
  };

  const scrollTo = () => {
    const element = document.getElementById('explore-live-node');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      minHeight={'100dvh'}
      flexGrow={1}
      paddingX={{ xs: '24px', md: '80px' }}
      paddingTop={{ xs: '130px', md: '230px' }}
      paddingBottom={{ xs: '32px', md: '230px' }}
      alignItems={'center'}
      justifyContent={'center'}
      component={'section'}
      position={'relative'}>
      <Stack zIndex={2} position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <Image priority src={backgrounds.subtract_2_splash} alt={'splash'} layout={'fill'} objectFit={'cover'} />
      </Stack>

      <Stack
        zIndex={3}
        position={'relative'}
        direction={{ xs: 'column', md: 'row' }}
        justifyContent={'space-between'}
        width={'min(1280px, 100%)'}
        alignItems={{ xs: 'center', md: 'flex-start' }}>
        <Stack gap={{ xs: 5, md: 7 }} width={'100%'} maxWidth={'465px'} zIndex={3}>
          <Stack gap={{ xs: 2, sm: 3 }} width={'100%'}>
            <Stack
              width={'fit-content'}
              alignItems={'center'}
              direction={'row'}
              justifyContent={'center'}
              gap={1}
              padding={'8px 16px'}
              sx={{
                backdropFilter: 'blur(10px)',
                border: '1px solid #FFFFFF14',
                boxShadow: '0px 0px 8px 0px #FFFFFF40 inset',
              }}>
              <Stack
                width={8}
                height={8}
                borderRadius={'50%'}
                bgcolor={'#FF5319'}
                sx={{ boxShadow: '0px 0px 0px 3.5px #FF53191A' }}
              />
              <Typography
                color={'#FDFDFD'}
                variant={'bodyMedium'}
                fontWeight={'700'}
                fontSize={{ xs: '14px', sm: '16px' }}
                lineHeight={{ xs: '18px', sm: '20px' }}>
                LIVE
              </Typography>
            </Stack>
            <Typography
              component={'h1'}
              variant={'displayMedium'}
              className={'clip-text'}
              fontSize={{ xs: '24px', md: '48px' }}
              lineHeight={{ xs: '32px', md: '68px' }}
              sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
              FEATURED SALES
            </Typography>
          </Stack>
          <Stack alignItems={{ xs: 'flex-start', md: 'center' }} gap={2} direction={{ xs: 'column', md: 'row' }}>
            <Stack width={{ xs: '140px', md: '180px' }} display={{ xs: 'none', md: 'block' }}>
              <HexagonalButton variant={'primary'} label={'VIEW ALL'} onClick={scrollTo} />
            </Stack>
            <Stack width={{ xs: '140px', md: '180px' }} display={{ xs: 'block', md: 'none' }}>
              <HexagonalButton variant={'primary'} label={'VIEW ALL'} size={'small'} onClick={scrollTo} />
            </Stack>
            <Stack width={{ xs: '198px', md: '269px' }} display={{ xs: 'none', md: 'block' }}>
              <HexagonalButton variant={'secondary'} label={'START YOUR LAUNCH'} onClick={openAdminPage} />
            </Stack>
            <Stack width={{ xs: '198px', md: '269px' }} display={{ xs: 'block', md: 'none' }}>
              <HexagonalButton
                variant={'secondary'}
                label={'START YOUR LAUNCH'}
                size={'small'}
                onClick={openAdminPage}
              />
            </Stack>
          </Stack>
        </Stack>

        {/* Right side app UI image */}
        <Stack
          position={{ xs: 'relative', md: 'absolute' }}
          right={{ md: 0 }}
          top={{ md: '-110px' }}
          width={{ xs: '100%', md: '50%', lg: '45%' }}
          mt={{ xs: 6, md: 0 }}
          alignSelf={{ xs: 'center', md: 'flex-end' }}
          zIndex={2}>
          <Image
            priority
            src={backgrounds.hero_bg_2}
            alt='LFG Core Launchpad Interface'
            width={824}
            height={569}
            className={'w-[420px] h-[285px] sm:w-[824px] sm:h-[560px] object-contain'}
          />
        </Stack>
      </Stack>

      <Stack zIndex={1} position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <Image src={icons.ic_wave_section_2} alt={''} layout={'fill'} objectFit={'cover'} />
      </Stack>
    </Stack>
  );
};
